/* eslint-disable no-tabs */
/* eslint-disable no-tabs */
<template>
    <svg style="position: absolute; width: 1px; height: 1px;" xmlns="http://www.w3.org/2000/svg">
        <symbol
            id="icon-minus"

            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            stroke-width="4"
            stroke-linecap="round"
            stroke-linejoin="round"
        >
            <line
                x1="4"
                y1="12"
                x2="19"
                y2="12"
            />
        </symbol>
        <symbol
            viewBox="0 0 256 256"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path d="M216,140H40a12,12,0,0,1,0-40H216a12,12,0,0,1,0,40Z" />
        </symbol>
        <symbol
            id="icon-cross"

            viewBox="0 0 48 48"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M8 8L40 40"
                stroke-width="6"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
            <path
                d="M8 40L40 8"
                stroke-width="6"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
        </symbol>

        <symbol
            id="icon-move"
            viewBox="0 0 32 32"
            xmlns="http://www.w3.org/2000/svg"
        >
            <polygon points="25 11 23.59 12.41 26.17 15 17 15 17 5.83 19.59 8.41 21 7 16 2 11 7 12.41 8.41 15 5.83 15 15 5.83 15 8.41 12.41 7 11 2 16 7 21 8.41 19.59 5.83 17 15 17 15 26.17 12.41 23.59 11 25 16 30 21 25 19.59 23.59 17 26.17 17 17 26.17 17 23.59 19.59 25 21 30 16 25 11"></polygon>
        </symbol>
    </svg>
</template>
